import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/en-gb';
import { EN, FR } from '../languages';

// Étape 5 (2026-11-02) : français par défaut. La langue vient du lien (?lng=), sinon du dernier choix sur ce navigateur ;
// à la connexion, celle enregistrée sur le compte de l'utilisateur l'emporte (applyUserLanguage).
export const SUPPORTED_LANGUAGES = ['fr', 'en'];
export const DEFAULT_LANGUAGE = 'fr';

// Dates (moment) dans la langue du back-office : noms des jours et des mois, premier jour de la semaine.
const applyMomentLocale = language => moment.locale(language === 'en' ? 'en-gb' : 'fr');

i18n.on('languageChanged', language => {
  applyMomentLocale(language);
  if (typeof document !== 'undefined') document.documentElement.lang = language;
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        translations: FR,
      },
      en: {
        translations: EN,
      },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    load: 'languageOnly',
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      wait: true,
    },
    detection: {
      order: ['querystring', 'localStorage'],
      lookupLocalStorage: 'app-language',
      caches: ['localStorage'],
    },
  });

applyMomentLocale(i18n.language);

/** Langue enregistrée sur le compte (renvoyée à la connexion) : appliquée si elle diffère de la langue affichée. */
export const applyUserLanguage = language => {
  if (language && SUPPORTED_LANGUAGES.includes(language) && i18n.language !== language) {
    return i18n.changeLanguage(language);
  }
  return Promise.resolve();
};

export default i18n;
